import React, { Component } from "react";
import moment from 'moment';
import DatePicker from 'react-datepicker';
import Select from 'react-select';
import { NotificationManager, NotificationContainer } from 'react-notifications';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import { Redirect, BrowserRouter, Route, Switch } from "react-router-dom";
import Logout from "./../../../loginService/logout";
const backend = require('../../../config.js').backend;
const changeFloat = require('../../service/excelService.js').changeFloat;
const roundup = require('../../service/excelService.js').roundup;


const desigsStyles = {
    control: base => ({
        ...base,
        height: '45px',
        minHeight: '35px'
    })
};

class NewPlan extends Component {

    constructor(props) {

        super(props);
        // super();

        this.state = {
            desigs: {},
            desigId: '',
            fundStartDate: new Date(),
            fundEndDate: new Date(),
            bankAccId: '',
            bankAccounts: [],
            redirectLogout: false
        }

        this.handleBankAccChange = this.handleBankAccChange.bind(this);
        this.handleChangeSourceFund = this.handleChangeSourceFund.bind(this);
        this.handleFundStartDateChange = this.handleFundStartDateChange.bind(this);
        this.handleFundEndDateChange = this.handleFundEndDateChange.bind(this);

    }


    componentDidMount() {

        this.handlePlanChange();

        this.getAllDesignames()
            .then((desigs) => {
                this.setState({ desigs: desigs });
            })

        this.getAllBankAccount()
            .then((bankAccounts) => {
                this.setState({ bankAccounts: bankAccounts });
            })

    }


    componentDidUpdate(prevProps) {
        // Typical usage (don't forget to compare props):
        if (this.state.desigs !== prevProps.desigs
            || this.state.bankAccId !== prevProps.bankAccId
            || this.state.fundStartDate !== prevProps.fundStartDate
            || this.state.fundEndDate !== prevProps.fundEndDate) {
            this.handlePlanChange();
        }
    }


    getAllDesignames = _ => {

        var that = this;

        // console.log('getAllDesigNames');
        return new Promise(function (resolve, reject) {

            var url = `api/v1/gift/alldesignames`;
            fetch(backend + url, {
                method: 'GET',
                credentials: "include"
            })
                .then(response => response.json())
                .then((data) => {
                    //   console.log(data);
                    if (data.redirect) {
                        that.setState({ redirectLogout: true })
                        window.location.reload(false);
                    }
                    else {
                        resolve(data);
                    }
                })
                .catch((err) => {
                    console.log('getAllDesignames error', err);
                    reject(err)
                })

        })

    }


    getAllBankAccount = _ => {

        var that = this;

        return new Promise(function (resolve, reject) {

            var url = `api/v1/bankacc`;
            fetch(backend + url, {
                method: 'GET',
                credentials: "include"
            })
                .then(response => response.json())
                .then((data) => {
                    // console.log(data);
                    if (data.redirect) {
                        that.setState({ redirectLogout: true })
                        window.location.reload(false);
                    }
                    else {
                        resolve(data);
                    }
                })
                .catch((err) => {
                    console.log('getAllBankAccount error', err);
                    reject(err)
                })

        })

    }

    renderSourceFund = () => {

        const { desigs } = this.state;
        var desigsList = [];

        Object.keys(desigs).forEach(function (key) {
            desigsList.push({
                'value': key,
                'label': desigs[key]
            })
        });

        desigsList.sort((a, b) => (a.label > b.label) ? 1 : -1);

        return desigsList
    }

    renderBankAccounts = () => {

        const { bankAccounts } = this.state;
        var bankAccountList = [];

        bankAccounts.forEach(function (item, index) {
            // console.log(item, index);
            bankAccountList.push({
                'value': item.BankAccID,
                'label': item.BankAccName
            })
        });

        bankAccountList.sort((a, b) => (a.label > b.label) ? 1 : -1);

        return bankAccountList
    }


    handleBankAccChange(account) {
        console.log(account)
        this.setState({ bankAccId: account.value });
    }

    handleChangeSourceFund = (desig) => {
        this.setState({ desigId: desig.value });
    }


    handleFundStartDateChange = (date) => {
        // console.log('handleFundStartDateChange');
        date = moment(date).format('YYYY-MM-DD');
        this.setState({
            fundStartDate: date
        });
    }


    handleFundEndDateChange = (date) => {
        // console.log('handleFundEndDateChange');
        date = moment(date).format('YYYY-MM-DD');
        this.setState({
            fundEndDate: date
        });
    }

    handlePlanChange = () => {
        this.props.sendBackPlan({
            desigId: this.state.desigId,
            bankAccId: this.state.bankAccId,
            fundStartDate: this.state.fundStartDate,
            fundEndDate: this.state.fundEndDate
        });
    }

    render() {

        const { redirectLogout } = this.state;

        if (redirectLogout) {
            return (
                <BrowserRouter>
                    <Switch>
                        <Route exact path="/logout" component={Logout} />
                        <Redirect to="/logout" />
                    </Switch>
                </BrowserRouter>
            )
        }

        var desigsList = this.renderSourceFund();
        var bankAccountList = this.renderBankAccounts();
        // this.handlePlanChange();

        var content = (<div>
            <div className="buttons col-sm-12 form-group">
                <label>Source fund</label>
                <div className="btn-group">
                    <Select
                        className='react-select-container'
                        // styles={desigsStyles} 
                        width='200px'
                        options={desigsList}
                        isSearchable="true"
                        placeholder="Source fund"
                        onChange={this.handleChangeSourceFund}
                    />
                </div>
            </div>

            <div className="buttons col-sm-12 form-group">
                <label>Linked Bank Account</label>
                <div className="btn-group">
                    <Select
                        className='react-select-container'
                        width='200px'
                        options={bankAccountList}
                        isSearchable="true"
                        placeholder="Bank Account"
                        onChange={this.handleBankAccChange}
                    />
                </div>
            </div>

            <div className="col-sm-12 form-group">
                <label>Start Date</label>
                <div className="startdate">
                    <DatePicker
                        selected={(this.state.fundStartDate === '') ? new Date() : new Date(this.state.fundStartDate)}
                        onChange={this.handleFundStartDateChange}
                        showMonthDropdown
                        showYearDropdown
                        scrollableMonthYearDropdown
                    />
                </div>
            </div>

            <div className="col-sm-12 form-group">
                <label>End Date</label>
                <div className="startdate">
                    <DatePicker
                        selected={(this.state.fundEndDate === '') ? new Date() : new Date(this.state.fundEndDate)}
                        onChange={this.handleFundEndDateChange}
                        showMonthDropdown
                        showYearDropdown
                        scrollableMonthYearDropdown
                    />
                </div>
            </div>
        </div>
        )

        return content
    }

}


class NewFundsList extends Component {

    constructor(props) {

        // super();
        super(props);

        this.state = {

            fundAccList: [],
            bankAccounts: [],
            bankAccountsDropDown: {},
            leftPercentage: 0,
            redirectLogout: false
        }

        this.handleChangeBankAccount = this.handleChangeBankAccount.bind(this);
        this.handleNameChange = this.handleNameChange.bind(this);
        this.handlePerChange = this.handlePerChange.bind(this);
        this.deleteAccount = this.deleteAccount.bind(this);


    }


    componentDidMount() {

        this.handleFundsChange();

        this.getAllBankAccount()
            .then((bankAccounts) => {
                this.setState({ bankAccounts: bankAccounts.object });
                this.setState({ bankAccountsDropDown: bankAccounts.list });
            })
    }

    componentDidUpdate(prevProps) {
        // Typical usage (don't forget to compare props):
        if (this.state.fundAccList !== prevProps.fundAccList) {
            this.handleFundsChange();
        }
    }

    handleNameChange(index, event) {
        console.log('handleNameChange, index', index)
        var fundAccList = this.state.fundAccList;
        var fundAcc = fundAccList[index];
        fundAcc.name = event.target.value;
        this.setState({ fundAccList: fundAccList });
    }

    handlePerChange(index, event) {
        console.log('handlePerChange, index', index)
        var fundAccList = this.state.fundAccList;
        var fundAcc = fundAccList[index];
        fundAcc.per = event.target.value;
        this.setState({ fundAccList: fundAccList });
    }


    handleChangeBankAccount = (index, account) => {
        // console.log(account, index)
        console.log('handleChangeBankAccount, index', index)

        var fundAccList = this.state.fundAccList;
        var fundAcc = fundAccList[index];
        fundAcc.bankAccId = account.value;

        this.setState({ fundAccList: fundAccList });

    }


    renderBankAccountList = (id, index) => {

        const { bankAccountsDropDown } = this.state;

        return (

            <Select
                className='react-select-container'
                styles={desigsStyles}
                options={bankAccountsDropDown}
                // defaultValue={{ value: id , label: name}}
                isSearchable="true"
                placeholder="Bank Account"
                onChange={(e) => this.handleChangeBankAccount(index, e)}
            />

        )

    }



    renderFundInputRow = (account, index) => {


        return (<tr>
            <td>
                <input className="form-control" type="text" value={account.name} onChange={(e) => this.handleNameChange(index, e)} />
            </td>
            <td>
                <div>
                    <input className="form-control" type="number" placeholder="Percentage (ONLY NUMBER ACCEPTED)" value={account.per} onChange={(e) => this.handlePerChange(index, e)} />
                </div>
            </td>
            <td>
                {this.renderBankAccountList(account.bankAccId, index)}
            </td>
            <td>
                <button type="button" className="btn btn-primary submit" onClick={() => this.deleteAccount(index)}>Delete</button>
            </td>

        </tr>)

    }


    deleteAccount = (index) => {

        var fundAccList = this.state.fundAccList;
        fundAccList.splice(index, 1)
        this.setState({ fundAccList: fundAccList })

    }

    handleNewFundAcc = _ => {

        console.log('handleNewFundAcc');

        var fundAccList = this.state.fundAccList;

        fundAccList.push({

            name: '',
            per: '',
            bankAccId: null

        })

        this.setState({ fundAccList: fundAccList })

    }


    getAllBankAccount = _ => {

        var that = this;
        var accountList = [];
        var accountObject = {}
        console.log('getAllBankAccount');

        return new Promise(function (resolve, reject) {

            var url = `api/v1/bankacc`;
            fetch(backend + url, {
                method: 'GET',
                credentials: "include"
            })
                .then(response => response.json())
                .then((data) => {
                    //   console.log(data);
                    if (data.redirect) {
                        that.setState({ redirectLogout: true })
                        window.location.reload(false);
                    } else {
                        data.forEach(function (item, index) {
                            // console.log(item, index);
                            accountList.push({
                                'value': item.BankAccID,
                                'label': item.BankAccName
                            })
                            accountObject[item.BankAccID] = item.BankAccName;

                        });

                        resolve({ list: accountList, object: accountObject });
                    }

                })
                .catch((err) => {
                    console.log('getAllBankAccount error', err);
                    reject(err)
                })

        })

    }


    handleFundsChange = () => {
        this.props.sendBackFundAccounts(
            this.state.fundAccList
        );
    }



    render() {
        var fundAccList = this.state.fundAccList;
        // this.handleFundsChange();

        const { redirectLogout } = this.state;

        if (redirectLogout) {
            return (
                <BrowserRouter>
                    <Switch>
                        <Route exact path="/logout" component={Logout} />
                        <Redirect to="/logout" />
                    </Switch>
                </BrowserRouter>
            )
        }

        let content = (
            <div>
                {(fundAccList.length > 0) ?
                    <div className='new-fund-acc-details'>
                        <label>Destination Funds</label>
                        <table className="fund-acc-table table table-striped table-hover ">
                            <tbody>
                                <tr>
                                    <th>Fund Name</th>
                                    <th>Percentage (%)</th>
                                    <th>Bank Account</th>
                                    <th>Actions</th>
                                </tr>

                                {fundAccList.map(this.renderFundInputRow)}

                                <div>
                                    <AddCircleIcon onClick={this.handleNewFundAcc} />
                                    <label>Add New Fund Account</label>
                                </div>

                            </tbody>
                        </table>
                    </div>
                    :
                    <div className='new-fund-acc-details'>
                        <AddCircleIcon onClick={this.handleNewFundAcc} />
                        <label>Add New Fund Account</label>
                    </div>
                }
            </div>
        )

        return content
    }

}


class NewPlanPopUp extends Component {

    constructor(props) {

        super(props);

        this.state = {
            plan: '',
            fundAccList: [],
            staffid: sessionStorage.getItem('id_e'),
            redirectLogout: false
        }

    }

    shouldComponentUpdate(nextProps, nextState) {
        return nextState.plan === this.state.plan
    }

    getPlanDetails = (plan) => {
        this.setState({ plan: plan });
        // console.log('getPlanDetails', plan);
    }

    getFundAccDetails = (fundAccList) => {
        this.setState({ fundAccList: fundAccList });
        // console.log('getFundAccDetails', fundAccList)
    }

    updatePlanList = _ => {
        // console.log('refresh updatePlanList')
        this.props.refresh();

    }

    handleCancel = _ => {
        // console.log('handleCancel')
        this.props.togglePopup();
    }


    closePopup = _ => {
        this.handleCancel();
    }

    addNewPlanWithFundAccsToSQL = () => {
        var plan = this.state.plan;
        var fundAccList = this.state.fundAccList;
        var { staffid } = this.state;
        var that = this;

        console.log('addNewPlanWithFundAccsToSQL', plan, fundAccList);

        var url = `api/v1/budgetplanwithacc/` + staffid;
        return fetch(backend + url, {
            method: 'POST',
            credentials: "include",
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ 'plan': plan, 'fundAccList': fundAccList })
        })
            .then(response => response.json())
            .then(data => {

                console.log(data);

                //if error
                if (data.redirect) {
                    that.setState({ redirectLogout: true })
                    window.location.reload(false);
                }
                else if (data.error) {
                    // console.log('data.error', data.error)
                    NotificationManager.error('New fund-raising project cannot be created, ' + JSON.stringify(data.error));
                }
                else {
                    NotificationManager.success('New fund-raising project is created successfully');
                    this.updatePlanList();
                    this.closePopup();
                }

            })
            .catch(err => {
                console.log(err);
                NotificationManager.error('New fund-raising project cannot be created, ' + err.toString());

            });



    }

    isPlanValid = () => {
        var errorMsg = ""

        var plan = this.state.plan;
        // var fundAccList = this.state.fundAccList;


        if (plan.desigId === "") {
            errorMsg = "Please choose a source fund!\n";
        }

        if (plan.bankAccId === "") {
            errorMsg = "Please choose a bank account for the source fund!\n";
        }

        plan.fundStartDate = moment(plan.fundStartDate).format('YYYY-MM-DD');
        plan.fundEndDate = moment(plan.fundEndDate).format('YYYY-MM-DD');

        // console.log(plan.fundStartDate, plan.fundEndDate, plan.fundStartDate > plan.fundEndDate)

        if (plan.fundStartDate > plan.fundEndDate) {

            errorMsg = errorMsg + "Please check start and end date of the project!\n"

        }


        return (errorMsg)

    }


    isFundsValid = _ => {

        const { fundAccList } = this.state;
        var total_per = 0;
        var result = {
            error: '',
            // warning: ''
        };

        if (fundAccList.length === 0) {
            result['error'] = 'Please add at least one fund account!'

        }

        fundAccList.forEach(function (acc, index) {
            console.log(acc);
            total_per += changeFloat(acc.per);

            // If any fund account never choose linked bank account
            if (acc.bankAccId === null) {
                result['error'] = 'Please choose a bank account!'
            }
        });

        total_per = roundup(total_per);

        if (total_per > 100 || total_per < 100) {

            result['error'] = "The total percentage is " + total_per + "%. Please check your inputs!"

        }

        // console.log(result)
        return result;

    }

    handleAddClick = () => {

        var error = this.isPlanValid();

        if (error) {
            alert(error);
        }

        else {

            var fundsValidation = this.isFundsValid();
            // console.log(fundsValidation)

            if (fundsValidation.error) alert(fundsValidation.error);

            else {
                this.addNewPlanWithFundAccsToSQL();
            }

        }


    }


    render() {

        const { redirectLogout } = this.state;

        if (redirectLogout) {
            return (
                <BrowserRouter>
                    <Switch>
                        <Route exact path="/logout" component={Logout} />
                        <Redirect to="/logout" />
                    </Switch>
                </BrowserRouter>
            )
        }

        return (
            <div className='popup'>

                <span className="close" onClick={this.handleCancel}>×</span>

                <div className='popup_inner'>

                    <div className="table-container2">
                        <h4 className='title'>Project Details</h4>

                        <NewPlan sendBackPlan={this.getPlanDetails} />
                        <NewFundsList sendBackFundAccounts={this.getFundAccDetails} />

                        <div className='buttons col-sm-12'>
                            <button type="button" className="btn btn-primary submit" onClick={this.handleAddClick}>Add</button>
                            <button type="button" className="btn btn-primary submit" onClick={this.handleCancel}>Cancel</button>
                        </div>

                    </div>
                    <NotificationContainer />

                </div>

            </div>
        )

    }

}

export default NewPlanPopUp;
